import { lazy, Suspense } from 'react';
import { SplashScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const Installation = lazy(() => import('src/pages/installation/integration-type'));
const EmailCheck = lazy(() => import('src/pages/installation/email-check'));
const CompanyRegistration = lazy(() => import('src/pages/installation/company-registration'));
const MultiStoreToken = lazy(() => import('src/pages/installation/multi-store-token'));
const SuccessfulMultiStoreRequest = lazy(
  () => import('src/pages/installation/successful-multi-store')
);

// Wrap components in Suspense — pages handle their own responsive layout via Tailwind
const LoadableInstallation = () => (
  <Suspense fallback={<SplashScreen />}>
    <Installation />
  </Suspense>
);

const LoadableEmailCheck = () => (
  <Suspense fallback={<SplashScreen />}>
    <EmailCheck />
  </Suspense>
);

const LoadableCompanyRegistration = () => (
  <Suspense fallback={<SplashScreen />}>
    <CompanyRegistration />
  </Suspense>
);

const LoadableMultiStoreToken = () => (
  <Suspense fallback={<SplashScreen />}>
    <MultiStoreToken />
  </Suspense>
);

const LoadableSuccessfulMultiStoreRequest = () => (
  <Suspense fallback={<SplashScreen />}>
    <SuccessfulMultiStoreRequest />
  </Suspense>
);

// ----------------------------------------------------------------------

export const installationRoutes = [
  {
    path: 'installation',
    children: [
      { path: 'integration-type', element: <LoadableInstallation /> },
      { path: 'email-check', element: <LoadableEmailCheck /> },
      { path: 'company-registration', element: <LoadableCompanyRegistration /> },
      { path: 'multi-store-token', element: <LoadableMultiStoreToken /> },
      { path: 'successful-request', element: <LoadableSuccessfulMultiStoreRequest /> },
    ],
  },
];
